import { PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export class PageBuilderColumnModel {
    static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.COLUMN,
            NAME: 'Colonne',
            ICON: 'view_column',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Colonne', READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'ORIENTATION', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Orientation', DS_DATAS: [
                    { ID: 'ROW', VALUE: 'Ligne' },
                    { ID: 'COLUMN', VALUE: 'Colonne' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'COLUMN' },
                { ID: 'ALIGNMENT', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Alignement', DS_DATAS: [
                    { ID: 'LEFT', VALUE: 'Gauche' },
                    { ID: 'CENTER', VALUE: 'Centré' },
                    { ID: 'RIGHT', VALUE: 'Droit' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'CENTER' },
                
            ]
        };
    }
}